<template>
  <analytics-sub-page
    title="Pay Analytics"
    icon="money-bill-wave"
    css-class="analytics-pay"
    default-label="Pay"
    :section-specs="sectionSpecs"
  >
    <stream-metrics ref="streamRef" />
  </analytics-sub-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import StreamMetrics from '@/pages/analyticsApp/components/StreamMetrics.vue';

const streamRef = ref(null);

// StreamMetrics renders three logical subsections (Users / Transfers /
// Transfer reasons). Each spec scopes capture to the matching
// `data-pdf-section` marker so the modal lists them separately.
const sectionFor = (sectionKey, hasDataKey, exportTableKey) => ({
  hasData: () => !!streamRef.value?.[hasDataKey],
  getContainerEl: () =>
    streamRef.value?.$el?.querySelector(`[data-pdf-section="${sectionKey}"]`) || streamRef.value?.$el,
  getExportTable: () => streamRef.value?.[exportTableKey]?.() ?? null,
});

const sectionSpecs = [
  { key: 'users', label: 'Users', ...sectionFor('users', 'hasUsersData', 'getUsersExportTable') },
  { key: 'transfers', label: 'Transfers', ...sectionFor('transfers', 'hasTransfersData', 'getTransfersExportTable') },
  {
    key: 'reasons',
    label: 'Transfer reasons',
    ...sectionFor('reasons', 'hasReasonsData', 'getReasonsExportTable'),
  },
];
</script>
